export enum PAGE_PERMISSIONS {
  PAGE_VIEW = 'CONTENT_VIEW',
  PAGE_WRITE = 'CONTENT_WRITE',
}
